"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewPortSize = void 0;
var ViewPortSize;
exports.ViewPortSize = ViewPortSize;

(function (ViewPortSize) {
  ViewPortSize["MEW"] = "MEW";
  ViewPortSize["DESKTOP"] = "DESKTOP";
})(ViewPortSize || (exports.ViewPortSize = ViewPortSize = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL2VudW1zL1ZpZXdQb3J0U2l6ZS50cyJdLCJuYW1lcyI6WyJWaWV3UG9ydFNpemUiXSwibWFwcGluZ3MiOiI7Ozs7OztJQUFZQSxZOzs7V0FBQUEsWTtBQUFBQSxFQUFBQSxZO0FBQUFBLEVBQUFBLFk7R0FBQUEsWSw0QkFBQUEsWSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBlbnVtIFZpZXdQb3J0U2l6ZSB7XG4gICAgTUVXID0gJ01FVycsXG4gICAgREVTS1RPUCA9ICdERVNLVE9QJyxcbn1cbiJdfQ==